import script from "./ScopeRichTextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ScopeRichTextEditor.vue?vue&type=script&setup=true&lang=js"

import "./ScopeRichTextEditor.vue?vue&type=style&index=0&id=4f492036&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f492036"]])

export default __exports__